import { unstableSetRender } from 'antd';
import { createRoot, type Root } from 'react-dom/client';

// antd's static APIs (message, notification, Modal.confirm) render through rc-util,
// which finds no render function on React 19's react-dom. Render them with createRoot.
const roots = new WeakMap<Element | DocumentFragment, Root>();

unstableSetRender((node, container) => {
  const root = roots.get(container) ?? createRoot(container);
  roots.set(container, root);
  root.render(node);

  return async () => {
    await Promise.resolve();
    root.unmount();
    roots.delete(container);
  };
});
